<template>
    <nav v-if="translations.length > 0" aria-label="Sprachwahl" class="lang-switch__nav">
        <ul role="list">
            <li v-for="translation in translations" :key="translation.language">
                <a
                    :href="translation.url"
                    :hreflang="translation.language"
                    :lang="translation.language"
                    :aria-label="getLanguageName(translation.language)"
                    :aria-current="isCurrentLanguage(translation.language) ? 'page' : null"
                >
                    {{ translation.language.toUpperCase() }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
const languageNames = {
    de: 'Deutsch',
    en: 'English',
    fr: 'Français',
    es: 'Español',
    it: 'Italiano',
    nl: 'Nederlands',
    pl: 'Polski',
    pt: 'Português',
};

export default {
    name: 'LangSwitch',
    data() {
        return {
            translations: [],
            currentLanguage: document.documentElement.lang || 'de',
        };
    },
    mounted() {
        this.loadTranslations();
    },
    methods: {
        loadTranslations() {
            const dataEl = document.getElementById('translations-data');
            if (dataEl) {
                try {
                    this.translations = JSON.parse(dataEl.textContent);
                } catch (e) {
                    console.error('Failed to parse translations:', e);
                }
            }
        },
        getLanguageName(langCode) {
            return languageNames[langCode] || langCode.toUpperCase();
        },
        isCurrentLanguage(langCode) {
            return langCode === this.currentLanguage;
        },
    },
};
</script>

